import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Services.module.css';

const serviceIcons = [
  '👶', '🩺', '🧠', '🌿', '🫃', '🧫', '🧬', '🦴', '🖥️', '🫁', '🩹', '🧪'
];

const Services = () => {
  const { t } = useTranslation();

  const services = [
    { icon: serviceIcons[0], name: t('services.neonatology.name'), desc: t('services.neonatology.desc') },
    { icon: serviceIcons[1], name: t('services.generalPediatrics.name'), desc: t('services.generalPediatrics.desc') },
    { icon: serviceIcons[2], name: t('services.childNeurology.name'), desc: t('services.childNeurology.desc') },
    { icon: serviceIcons[3], name: t('services.pediatricAllergology.name'), desc: t('services.pediatricAllergology.desc') },
    { icon: serviceIcons[4], name: t('services.pediatricGastroenterology.name'), desc: t('services.pediatricGastroenterology.desc') },
    { icon: serviceIcons[5], name: t('services.pediatricNephrology.name'), desc: t('services.pediatricNephrology.desc') },
    { icon: serviceIcons[6], name: t('services.pediatricEndocrinology.name'), desc: t('services.pediatricEndocrinology.desc') },
    { icon: serviceIcons[7], name: t('services.pediatricRheumatology.name'), desc: t('services.pediatricRheumatology.desc') },
    { icon: serviceIcons[8], name: t('services.instrumentalDiagnosis.name'), desc: t('services.instrumentalDiagnosis.desc') },
    { icon: serviceIcons[9], name: t('services.pulmonology.name'), desc: t('services.pulmonology.desc') },
    { icon: serviceIcons[10], name: t('services.therapeutic.name'), desc: t('services.therapeutic.desc') },
    { icon: serviceIcons[11], name: t('services.laboratory.name'), desc: t('services.laboratory.desc') },
  ];

  return (
    <section id="services" className={styles.section}>
      <div className={styles.header}>
        <p className={styles.label}>{t('services.label')}</p>
        <h2 className={styles.title}>{t('services.title')}</h2>
        <p className={styles.desc}>
          {t('services.desc')}
        </p>
      </div>
      <div className={styles.grid}>
        {services.map(({ icon, name, desc }) => (
          <div key={name} className={styles.card}>
            <div className={styles.icon}>{icon}</div>
            <p className={styles.name}>{name}</p>
            <p className={styles.cardDesc}>{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
